export const QA_NAME_LISTING_PROFILE_VIEWINGS_RETRY = 'listingViewingsRetry'

export const QA_NAME_LISTING_PROFILE_VIEWINGS_TABLE = 'listingViewings'

export const LISTING_PROFILE_VIEWINGS_SKELETON_ROWS = 3

export const LISTING_VIEWINGS_PAGE_SIZE = 20

export const ListingViewingColumnName = {
  Applicant: 'applicant',
  DateTime: 'start',
  Status: 'status',
}

// TODO: the tab runs on fixed columns until the backend registers its table
// config and the table loads it through useTableConfigLoader
export const LISTING_VIEWING_COLUMNS_CONFIG = {
  [ListingViewingColumnName.Applicant]: {
    index: 1,
    name: ListingViewingColumnName.Applicant,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileViewingsApplicantColumnKey',
    visible: true,
    width: 260,
  },
  [ListingViewingColumnName.DateTime]: {
    index: 0,
    name: ListingViewingColumnName.DateTime,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileViewingsDateTimeColumnKey',
    visible: true,
    width: 292,
  },
  [ListingViewingColumnName.Status]: {
    index: 2,
    name: ListingViewingColumnName.Status,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileViewingsStatusColumnKey',
    visible: true,
    width: 180,
  },
}
